import React from "react";
import "./TeamCenterIntegrationNX.css";
import Teacher from "../../../../../assets/images/plmimplementationimage/Teacher-amico.png";
import TICatiaOverview from "./TINXOverview";
import Letsgetintouch from "../../../BusinessProcessAndChangeManagement/Letsgetintouch";
import FloatingContactUs from "../../../../floting_contact/FloatingContactUs";
import { NavLink } from "react-router-dom";

const TeamCenterIntegrationNX = () => {
  return (
    <section className="TINX-management">
      <div className="banner">
        <div className="banner-content">
          <img src={Teacher} alt="teacher" className="banner-image" />
          <div className="banner-text">
            <h4 className="TINX-process-h4">Teamcenter Integration for NX</h4>
          </div>
        </div>
      </div>
      <div>
         <FloatingContactUs />
      </div>

      <div className="container">
        <TICatiaOverview />
        <div className="benefits">
          <h4 className="TINX-page-heading">Unlock the Power :</h4>
          <h5 className="TINX-subheading">
            Discover the Transformative Benefits of NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              Less time spent by design teams and partners finding the right NX
              data
            </li>
            <li>
              Reduced development cycle times for distributed global design
              teams and their partners{" "}
            </li>
            <li>
              Faster product change and approval processes that facilitate
              shorter time-to market
            </li>
            <li>
              Higher levels of understanding and communication among product
              teams throughout the supply chain
            </li>
            <li>
              A single source of product information in support of your complete
              design through- manufacturing process
            </li>
          </ul>
        </div>

        <div className="solutions container">
  <div className="solutions-content">
    <div className="row">
      {/* Left Section: TINX Solutions */}
      <div className="col-md-6 col-12">
        <h4 className="TINX-page-heading">Our Solutions</h4>
        <p className="plmimplementationparagraph">
          2TIER & 4TIER integration, synchronize title block using Teamcenter
          database attributes, Mechanical Properties Synchronization, Seed
          Parts, Configuration of NX to JT Translation, NX Manager, SQL
          Optimization, Additional Columns, Complex Attribute Mapping like
          project, workflow attributes, occurrence note type,
          EPM-tessellation-handler, Legacy data import using UG Import, UG
          Clone, IPS Data Upload, starting NX in standby mode, enabling icon
          display for various objects, and so on.
        </p>
      </div>

      {/* Right Section: Quick Links */}
      <div className="col-md-6 col-12">
        <div className="quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/solidwork-integration"}>
                Teamcenter Integration for SolidWorks
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/pro-engineer-integration"}>
                Teamcenter Integration for Creo Pro/ENGINEER
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/catia-integration"}>
              Teamcenter Integration for CATIA
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/autocad-integration"}>
                Teamcenter Integration for AutoCAD
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/solidedge-integration"}>
                Teamcenter Integration for Solid Edge
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration"}>
                MCAD integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/ecad-integration"}>
              Ecad integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/business-process-management"}>
                Business Process and Change Management
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


        <div className="solutions">
          
          <h4 className="TINX-page-heading">Performance Tuning</h4>
          <p className="plmimplementationparagraph">
            We help customer to achieve optimum performance of NX Teamcenter
            integration by adapting a process of analyze, rectify, verify and
            monitor the performance which helps us tune the system to enable the
            best performance at s/w, hardware, network level.
          </p>
          {/* <ul className="custom-bullets">
            <li>T4S, T40, and T4EA Installation </li>
            <li>
              Data flow modelling for business object and their lifecycle{" "}
            </li>
            <li>TCL programming for mapping </li>
            <li>T4S_Gateway explorer configuration </li>
            <li>Data Model Mapping of Teamcenter and SAP business objects </li>
            <li>Teamcenter and SAP Login configuration </li>
            <li>Configuration for MM & MBOM transfer </li>
            <li>
              Workflow Development for automatic transfer of MM & MBOM on
              receiving maturity{" "}
            </li>
            <li>
              Change management across the SAP & Teamcenter workflow development{" "}
            </li>
          </ul> */}
        </div>

        <div className="best-practices">
          <h4 className="TINX-page-heading">Best Practices</h4>
          <p className="plmimplementationparagraph">
          We help customer to enable best practices while performing various activities in manage mode environments on CAD/CAM/CAE data create, configure, edit, along with relationship and associated auxiliary files, JT conversion, storing mechanical properties, working in multiple sessions, CAD centric data transfer in multisite, family tables, using precise, baseline, effectivity, variants and options, partial loading and so on. 
          </p>
        </div>

        <div className="migration">
          <h4 className="TINX-page-heading">Migration</h4>
          <p className="plmimplementationparagraph">
          We helps customer to migrate the legacy data by ensuring end to end migration process by using CMM efficiently to achieve quality migration to optimize CAD processes based on future customer business needs. 
          </p>
          <h5 className="migration-heading">I-deas to NX Migration</h5>
          <p className="plmimplementationparagraph">
          Migration of customer from I-deas environment into the NX environment. 
          </p>
          <ul className="custom-bullets">
            <li>Data Assessment & Analysis</li>
            <li>Data Cleanup</li>
            <li>Data Migration and Testing</li>
            <li>Production Rollout</li>
          </ul>
          <h5 className="migration-heading">
          Pro/ENGINEER design data migration to NX
          </h5>
          <ol className="custom-ordered-list">
            <li>Loading PRO/E data and corresponding metadata in Teamcenter  </li>
            <li>Content Migration Manager for PRO/E configuration  </li>
            <li>
            Establish a process of migration & data verification like drawing, model, BOM etc. 
            </li>
          </ol>

          <h5 className="migration-heading">
          CATIA design data migration to NX
          </h5>
          <ol className="custom-ordered-list">
            <li>Loading CATIA data and corresponding metadata in Teamcenter   </li>
            <li>Content Migration Manager for CATIA configuration </li>
            <li>
            Establish a process of migration & data verification like drawing, model, BOM etc.  
            </li>
          </ol>

          <h5 className="migration-heading">
          SolidWorks design data migration to NX
          </h5>
          <ol className="custom-ordered-list">
            <li>Loading SolidWorks data and corresponding metadata in Teamcenter </li>
            <li>Content Migration Manager for SolidWorks configuration  </li>
            <li>
            Establish a process of migration & data verification like drawing, model, BOM etc.
            </li>
          </ol>
        </div>
      </div>
      <Letsgetintouch />
    </section>
  );
};

export default TeamCenterIntegrationNX;
